var Shopify = Shopify || {};

Shopify.optionsMap = {};
class CustomVariants extends HTMLElement {
  constructor() {
    super();

    const sizeWrap = document.querySelector('[data-size-wrap]');
    const sortValue = sizeWrap.querySelectorAll('.variant-input');
    let sortObj = [];
    sortValue.forEach(sort => {
      sortObj.push(sort.dataset.value);
    })
var sizes = ["0.5","0.6","0.7","0.8","0.9","1","1.1","1.2","1.3","1.4","1.5","1.6","1.7","1.8","1.9","2","2.1","2.2","2.3","2.4","2.5","2.6","2.7","2.8","2.9","3","3.5","4","4.5","5","5.5","6","6.5","7","7.5","8","8.5","9","9.5","10","10.5","11","11.5","12","12.5","13","13.5","14","14.5","15","15.5","16","16.5","17","17.5","18","18.5","19","19.5","20","20.5","21","21.5","22","22.5","23","23.5","24","24.5","25","25.5","26","26.5","27","27.5","28","28.5","29","29.5","30","30.5","31","31.5","32","32.5","33","33.5","34","34.5","35","35.5","36","36.5","37","37.5","38","38.5","39","39.5","40","40.5","41","41.5","42","42.5","43","43.5","44","44.5","45","45.5","46","46.5","47","47.5","48","48.5","49","49.5","50","50.5","51","51.5","52","52.5","53","53.5","54","54.5","55","55.5","56","56.5","57","57.5","58","58.5","59","59.5","60"];
sortObj.sort(function (a, b) {
    const aNew = a.split("x");
    const bNew = b.split("x");
    if (aNew[0] === bNew[0]){
        const aSize = parseFloat(a.split("x")[1]);
        const bSize = parseFloat(b.split("x")[1]);
        return sizes.indexOf(aSize.toFixed(1)) - sizes.indexOf(bSize.toFixed(1));
    } else {
        const aSize = parseFloat(a.split("x")[0]);
        const bSize = parseFloat(b.split("x")[0]);
        return sizes.indexOf(aSize.toFixed(1)) - sizes.indexOf(bSize.toFixed(1));
    }
});






    
    sortObj.forEach((sort,index) => {
      sizeWrap.querySelector(`.variant-input[data-value="${sort}"]`).classList.add(`order-${index}`);
    })

    const colorWrap = document.querySelector('[data-color-variants]');
    const colorsortValue = colorWrap.querySelectorAll('.variant-input');
    
    let colorsortObj = [];
    colorsortValue.forEach(sort => {
      colorsortObj.push(sort.dataset.value);
    });
    colorsortObj.sort(function (a, b) {
      if (a < b) {
        return -1;
      }
      if (a > b) {
        return 1;
      }
      return 0;
    });
    colorsortObj.forEach((sort,index) => {
      colorWrap.querySelector(`.variant-input[data-value="${sort}"]`).classList.add(`order-${index}`);
    })
    
    this.updateOptions();
    this.linkOptionSelectors(window.productVariantsJSON);

    this.addEventListener('change', this.onVariantChange);

    
    const fieldsets = this.querySelector('[data-color-variants]');
    
    const finishedSets = this.querySelector('[data-finished-value]');
    var colorSwatch = fieldsets.querySelectorAll('.variant-input');
    var finishedSwatch = finishedSets.querySelectorAll('.variant-input');
    colorSwatch.forEach(clrswtch => {
      clrswtch.classList.remove('available');
      clrswtch.classList.add('sold-out');
    });
    Shopify.optionsMap[this.options[0]].forEach((optionName) => {
      fieldsets.querySelector(`.variant-input[data-value="${this.handleize(optionName)}"]`).classList.remove('sold-out');
      fieldsets.querySelector(`.variant-input[data-value="${this.handleize(optionName)}"]`).classList.add('available');
    });

    var kety = this.options[0] + ' / ' + this.options[1]
    
    if(Shopify.optionsMap[kety] != undefined) {
      finishedSwatch.forEach(clrswtch => {
        clrswtch.classList.remove('available');
        clrswtch.classList.add('sold-out');
      });
      
      
      Shopify.optionsMap[kety].forEach((optionName) => {
        finishedSets.querySelector(`.variant-input[data-value="${this.handleize(optionName)}"]`).classList.remove('sold-out');
        finishedSets.querySelector(`.variant-input[data-value="${this.handleize(optionName)}"]`).classList.add('available');
      });  
    }
    
    
  }
  linkOptionSelectors(product) {
    for (var i=0; i<product.length; i++) {
      var variant = product[i];
      if (variant.available) {
        // Gathering values for the 1st drop-down.
        Shopify.optionsMap['root'] = Shopify.optionsMap['root'] || [];
        Shopify.optionsMap['root'].push(variant.option1);
        Shopify.optionsMap['root'] = Shopify.uniq(Shopify.optionsMap['root']);
        
        // Gathering values for the 2nd drop-down.
        if (product[i].options.length > 1) {
          var key = variant.option1;
          Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];          
          Shopify.optionsMap[key].push(variant.option2);
          Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
        }

        // Gathering values for the 2nd drop-down.
        if (product[i].options.length === 3) {
          var key = variant.option1 + ' / ' + variant.option2;
          Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
          Shopify.optionsMap[key].push(variant.option3);
          Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);

        }
      }
    }
    return Shopify.optionsMap;
  }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.linkOptionSelectors(window.productVariantsJSON);
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('.variantLabel'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });

  }
  updateMasterId() {
    
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
    if(this.currentVariant) {
      window.location.href = `/products/${this.currentVariant.handle}?variant=${this.currentVariant.id}`;
      
    } else {
      
      const fieldsets = this.querySelector('[data-color-variants]');
      var colorSwatch = fieldsets.querySelectorAll('.variant-input');
      
      colorSwatch.forEach(clrswtch => {
        clrswtch.classList.remove('available');
        clrswtch.classList.add('sold-out');
      });
      
      var lengthShopifyOption = Shopify.optionsMap[this.options[0]].length;
      
      Shopify.optionsMap[this.options[0]].forEach((optionName) => {
        if(fieldsets.querySelector(`.variant-input[data-value="${this.handleize(optionName)}"]`) != null) {
          fieldsets.querySelector(`.variant-input[data-value="${this.handleize(optionName)}"]`).classList.remove('sold-out');
          fieldsets.querySelector(`.variant-input[data-value="${this.handleize(optionName)}"]`).classList.add('available');  
        }
      });

      if(fieldsets.querySelector(`.variant-input[data-value="${this.handleize(Shopify.optionsMap[this.options[0]][0])}"] input`)) {
        fieldsets.querySelector(`.variant-input[data-value="${this.handleize(Shopify.optionsMap[this.options[0]][0])}"] input`).checked = true;  
      }
      
      const finishedSets = this.querySelector('[data-finished-value]');
      var finishedSwatch = finishedSets.querySelectorAll('.variant-input');

      
      if(lengthShopifyOption > 0) {
        var kety = this.options[0] + ' / ' + Shopify.optionsMap[this.options[0]][0]
      } else {
        var kety = this.options[0] + ' / ' + this.options[1]  
      }
      
      if(Shopify.optionsMap[kety] != undefined) {
        finishedSwatch.forEach(clrswtch => {
          clrswtch.classList.remove('available');
          clrswtch.classList.add('sold-out');
        });
        
        
        Shopify.optionsMap[kety].forEach((optionName) => {
          finishedSets.querySelector(`.variant-input[data-value="${this.handleize(optionName)}"]`).classList.remove('sold-out');
          finishedSets.querySelector(`.variant-input[data-value="${this.handleize(optionName)}"]`).classList.add('available');
        });
        
        finishedSets.querySelector(`.variant-input[data-value="${this.handleize(Shopify.optionsMap[kety][0])}"] input`).checked = true;      
      }

      let searchObject = { option1: this.options[0], option2: this.options[1] };
      if(lengthShopifyOption > 0) {
        searchObject = { option1: this.options[0], option2: Shopify.optionsMap[this.options[0]][0] };
      } 

      const index = this.getVariantData().find(obj => {
        return Object.keys(searchObject).every(key => {
          return obj[key] === searchObject[key];
        });
      });

      
      
      if(index) {
        // console.log('this--currentVariant ========>', this.currentVariant)
        window.location.href = `/products/${index.handle}?variant=${index.id}`;
      } 
      this.updateCartButton();
      // alert('This variant is not available');
      
    }
    
  }
  updateCartButton(evt) {
    var classes = {
      disabled: 'disabled',
      hidden: 'hide',
    };
    this.selectors = {
        variantsJson: '[data-variant-json]',
        currentVariantJson: '[data-current-variant-json]',
        form: '.product-single__form',
        addToCart: '[data-add-to-cart]',
        addToCartText: '[data-add-to-cart-text]',
  
    };
    var variant = this.currentVariant;
    var cartBtn = document.querySelector(this.selectors.addToCart);
    var cartBtnText = document.querySelector(this.selectors.addToCartText);

    if (variant) {
      if (variant.available) {
        // Available, enable the submit button and change text
        cartBtn.classList.remove(classes.disabled);
        cartBtn.disabled = false;
        var defaultText = cartBtnText.dataset.defaultText;
        cartBtnText.textContent = defaultText;
      } else {
        // Sold out, disable the submit button and change text
        cartBtn.classList.add(classes.disabled);
        cartBtn.disabled = true;
        cartBtnText.textContent = theme.strings.soldOut;
      }
    } else {
      // The variant doesn't exist, disable submit button
      cartBtn.classList.add(classes.disabled);
      cartBtn.disabled = true;
      cartBtnText.textContent = theme.strings.unavailable;
    }
  }
  getVariantData() {
    this.variantData = window.productVariantsJSON;
    return this.variantData;
  }
  handleize(str) {
    str = str.toLowerCase().replace('.', '').replace('è', 'e');
      
    var toReplace = ['"', "'", "\\", "(", ")", "[", "]"];
    
    // For the old browsers
    for (var i = 0; i < toReplace.length; ++i) {
        str = str.replace(toReplace[i], "");
    }

    str = str.replace(/\W+/g, "-");

    if (str.charAt(str.length - 1) == "-") {
        str = str.replace(/-+\z/, "");
    }

    if (str.charAt(0) == "-") {
        str = str.replace(/\A-+/, "");
    }

    return str
  }
}

customElements.define('custom-variants', CustomVariants);
